import { graphql } from "../../../services/wp.api.service";

const query = `
mutation UpdateFacilitatorAccount($id: ID!, $contactInformation: Facilitator_Contactinformation_Input!) {
	updateFacilitator(input: {id: $id, contactInformation: $contactInformation}) {
	  facilitator {
		databaseId
	  }
	  clientMutationId
	}
}
`;


export const updateFacilitatorAccount = (useMutation, options) => useMutation(
	["update_my_facilitator_account"],
	(variables) => graphql({
		query,
		variables
	}).
		then(({ data }) => {
			if (data.errors) {
				throw new Error(data.errors[0].message);
			}

			return data.data.updateFacilitator;
		}),
	{
		...options
	}
);
